// extracted by mini-css-extract-plugin
export var content = "_oi-1";
export var fullScreen = "_oi-0";